import {cloneDeep} from '@naverpay/hidash/cloneDeep'
import {pickBy, isEmpty, isNil} from 'lodash/fp'

/** value 를 변환 합니다. */
export function mapValueKeys<T extends object, TResult>(
    callback: (value: T[keyof T], key: keyof T) => TResult,
    object: T,
): {[P in keyof T]: TResult} {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result: any = {}
    Object.keys(object).forEach((originKey) => {
        const key = originKey as keyof T
        const value = object[key]
        result[key] = callback(value, key)
    })
    return result as {[P in keyof T]: TResult}
}

/** 포함여부를 확인합니다. */
export function someValueKeys<T extends object>(
    callback: (value: T[keyof T], key: keyof T) => boolean,
    object: T,
): boolean {
    return Object.keys(object).some((originKey) => {
        const key = originKey as keyof T
        const value = object[key]
        return callback(value, key)
    })
}

/** state 를 반환합니다 */
export function reduceValueKeys<S, T extends object>(
    callback: (acc: S, value: T[keyof T], key: keyof T) => S,
    initialState: S,
    object: T,
): S {
    return Object.keys(object).reduce<S>((acc, originKey) => {
        const key = originKey as keyof T
        const value = object[key]
        return callback(acc, value, key)
    }, initialState)
}

/** 허용되는 state 만 반환합니다. */
export function filterValueKeys<S extends object, T extends object>(
    callback: (value: T[keyof T], key: keyof T) => boolean,
    object: T,
): S {
    return reduceValueKeys<S, T>(
        (acc, value, key) => {
            if (callback(value, key)) {
                return {
                    ...acc,
                    [key]: value,
                }
            }
            return acc
        },
        {} as S,
        object,
    )
}

/** 타입유지한 복사객체를 반환합니다 */
export function cloneTypePreservedObject<T>(source: T): T {
    return cloneDeep(source) as T
}

/** index를 key prefix를 붙인 key로 변환 */
export const createKey = (key: string) => (index: number) => `${key}_${index}`

/** 주문서 api 조회시 유효하지 않은 parameter 를 포함하지 않는 객체 반환 */
export const pickWithOutNil = (obj: object) => {
    return pickBy((item) => !(isNil(item) || isEmpty(item)), obj)
}
